import fetch from 'isomorphic-fetch';
import { url } from '@ts/utils/url';

export type Asset = {
  '@id': string;
  '@type': string;
  description: string;
  review_state?: string;
  title?: string;
};

export type ImageDto = {
  id: string;
  src: string;
  caption: string;
  credits: string;
  mode: 'landscape' | 'portrait';
  position: 'centered' | 'right' | 'left';
  overflow: boolean;
  parallax: boolean;
  widthPercent: number;
  width: number;
  height: number;
};

export class AssetsService {
  constructor(private readonly viewUrl: string = url.getViewUrl()) {}

  getImage = async (id: string) => {
    const url = `${this.viewUrl}/${id}`;

    const settings: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    const response = await fetch(url, settings);

    if (!response.ok) {
      const msg = await response.text();
      throw new Error(`Status code:${response.status}\nError:${msg}`);
    }

    const res = await response.json();

    const imageDto: ImageDto = {
      id,
      src: res.image.download,
      caption: res.image_caption || '',
      credits: (res.image_credit && res.image_credit.data) || '',
      mode: res.mode.token,
      position: (res.position && res.position.token) || 'centered',
      overflow: res.overflow,
      parallax: res.parallax,
      widthPercent: res.width,
      width: res.image.width,
      height: res.image.height,
    };

    return imageDto;
  };

  getAssets = async (): Promise<Asset[]> => {
    const settings: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    const response = await fetch(this.viewUrl, settings);

    if (!response.ok) {
      const msg = await response.text();
      throw new Error(`Status code:${response.status}\nError:${msg}`);
    }

    const assets = await response.json();

    return assets.items;
  };
}
